const CustomSurveyPublicReportConstants = {
  PASS_PRESENCE: 'Pass Presence',
  VERIFY_PASS: 'Verify Pass',
};

export default CustomSurveyPublicReportConstants;



// WEBPACK FOOTER //
// ./src/constants/Constants.js